<template>
  <section class="toast" :class="classes">
    <p>{{ toastState.text }}</p>
  </section>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {GETTER_TOAST_STATE} from '@/store/types';

  export default {
    name: 'toast',
    computed: {
      ...mapGetters({
        toastState: GETTER_TOAST_STATE,
      }),
      classes() {
        const classes = [this.toastState.theme, `position-${this.toastState.position}`];

        if (this.toastState.show) {
          classes.push('show');
        }

        return classes;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .toast {
    position: absolute;
    left: 0;
    right: 0;
    width: max-content;
    max-width: 90%;
    padding: 8px 15px;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
    margin: 0 auto;
    visibility: hidden;
    background-color: color(black, brand);

    &.position-bottom {
      bottom: 30px;
    }

    &.position-top {
      top: 30px;
    }

    &.show {
      visibility: visible;
      z-index: 200001;
    }

    &.show.position-bottom {
      animation: fadein-bottom 0.5s, fadeout-bottom 0.5s 2.5s;
    }

    &.show.position-top {
      animation: fadein-top 0.5s, fadeout-top 0.5s 2.5s;
    }

    &.primary {
      background-color: color(dodgerBlue, brand);
    }

    &.success {
      background-color: color(mountainGreen, brand);
    }

    &.warn {
      background-color: color(carrotOrange, brand);
    }

    &.danger {
      background-color: color(crimson, brand);
    }
  }

  @keyframes fadein-bottom {
    from { bottom: 0; opacity: 0; }
    to   { bottom: 30px; opacity: 1; }
  }

  @keyframes fadeout-bottom {
    from { bottom: 30px; opacity: 1; }
    to   { bottom: 0; opacity: 0; }
  }

  @keyframes fadein-top {
    from { top: 0; opacity: 0; }
    to   { top: 30px; opacity: 1; }
  }

  @keyframes fadeout-top {
    from { top: 30px; opacity: 1; }
    to   { top: 0; opacity: 0; }
  }
</style>
